module.exports = __webpack_public_path__ + "img/stock5.f07092b4.png";